// Copyright ©️ 2026 eVolve MEP, LLC

import { Flex, Box, Text, Switch, Anchor, Title } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { isNotNil } from 'helpers/isNotNil';

export type ManageRevitRolesOptInProps = {
  optIn: boolean | null;
  setOptIn: (optInToCustomRolePermissions: boolean) => void;
};

export const ManageRevitRolesOptIn = ({ optIn, setOptIn }: ManageRevitRolesOptInProps) => (
  <Box
    p="md"
    style={{
      backgroundColor: 'var(--mantine-color-gray-0)',
      borderRadius: '8px',
      border: '1px solid var(--mantine-color-gray-2)',
    }}
  >
    <Flex p="sm" justify="space-between" align="center" gap="md">
      <EvolveIcon icon="Encrypted" color="primary" size="xl" />
      <Title size="md">
        Custom Permissions
        <Text size="sm" mt="xs">
          {isNotNil(optIn) ? (
            <>
              EVOLVE has added custom overrides to your permissions. Disabling this toggle will revert the overridden
              user roles back to the settings displayed below.{' '}
              <Anchor className="link" href="https://help-foresite.evolvemep.com/article/ngf3gh1lsq" target="_blank">
                <b>Learn More</b>.
              </Anchor>{' '}
            </>
          ) : (
            <>
              EVOLVE can create custom permission overrides. Contact support at{' '}
              <Anchor className="link" href="mailto:support@evolvemep.com" target="_blank">
                <b>support@evolvemep.com</b>
              </Anchor>{' '}
              or{' '}
              <Anchor className="link" href="https://help-foresite.evolvemep.com/article/ngf3gh1lsq" target="_blank">
                <b>visit our documentation</b>.
              </Anchor>{' '}
            </>
          )}
        </Text>
      </Title>
      {isNotNil(optIn) && (
        <Switch
          labelPosition="right"
          mt="md"
          size="md"
          checked={optIn}
          onChange={(event) => setOptIn(event.currentTarget.checked)}
        />
      )}
    </Flex>
  </Box>
);
